import { createReducer, on, Action } from '@ngrx/store';

import * as actions from './venues-images.actions';
import * as Utils from '@shared/core/utils';

const initialState: OLO.State.VenuesImages = {
    default: [],
    forList: [],
    forDetails: [],
    forWeb: [],
    forWebThumb: [],
    forMobile: [],
    forPushNotifications: [],
    forLogo: [],
};
export const venueImagesReducerFn = createReducer(
    initialState,
    on(actions.VenueImagesRequest, (state, action) => {
        let imagesType: string = Utils.Images.toImageTypeString(action.imageType);

        const notExistingImages: number[] = action.ids.filter((id) => !state[imagesType].find((img: OLO.State.LocationsImages.ImageStateObj) => img.Id === id));

        return {
            ...state,
            [imagesType]: [
                ...state[imagesType].map((image) => {
                    if (action.ids.includes(image.Id)) {
                        return {
                            ...image,
                            isDownloading: true,
                            hasSucceeded: false,
                            hasFailed: false,
                        };
                    }

                    return image;
                }),

                ...notExistingImages.map((id) => ({
                    Id: id,
                    isDownloading: false,
                    hasSucceeded: false,
                    hasFailed: false,
                    data: null,
                })),
            ],
        };
    }),
    on(actions.VenueImagesSuccessRequest, (state, action) => {
        let imagesType: string = Utils.Images.toImageTypeString(action.imageType);

        return {
            ...state,
            [imagesType]: state[imagesType].map((image) => {
                const imageIsUpdating = action.ids.includes(image.Id);
                if (imageIsUpdating) {
                    const newImage = action.payload.find((obj) => obj.ParentId === image.Id);

                    return {
                        ...image,
                        isDownloading: false,
                        hasSucceeded: true,
                        hasFailed: true,
                        data: newImage || null,
                    };
                }

                return image;
            }),
        };
    }),
    on(actions.VenueImagesErrorRequest, (state, action) => {
        let imagesType: string = Utils.Images.toImageTypeString(action.imageType);

        return {
            ...state,
            [imagesType]: state[imagesType].map((image) => {
                if (action.ids.includes(image.Id)) {
                    return {
                        ...image,
                        isDownloading: false,
                        hasSucceeded: false,
                        hasFailed: true,
                    };
                }

                return image;
            }),
        };
    }),
);

export function venueImagesReducer(state: OLO.State.VenuesImages | undefined, action: Action) {
    return venueImagesReducerFn(state, action);
}
